module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_yoso_studio@3x-556351c132cf9bc54512cad40a1ca539.webp";